export default __webpack_public_path__ + "static/media/CallFlash.86558354.wav";